import { render } from "./EmailValidation.vue?vue&type=template&id=179be5e8&scoped=true&ts=true"
import script from "./EmailValidation.vue?vue&type=script&lang=ts"
export * from "./EmailValidation.vue?vue&type=script&lang=ts"

import "./EmailValidation.vue?vue&type=style&index=0&id=179be5e8&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-179be5e8"]])

export default __exports__